import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function SimgeKarabogaPage() {
  return <AttorneyBioTemplate attorney={attorneys['simge-karaboga-ozdemir']} />;
}
